<template>
  <div class="blog-header">
    <div class="wrp">
      <div class="blog-tabs">
        <div class="blog-tabs-item" @click="select('Все')" :class="{active: select_category == 'Все'}">
          Все
        </div>
        <div v-for="item in categories.slice(0, 5)" @click="select(item.id)" :key="item.id+'nav_blog'" :class="{active: select_category == item.id}" class="blog-tabs-item">
          {{ item.name }}
        </div>
      </div>
      <div class="blog-tabs" v-if="categories.length > 5">
        <div v-for="item in categories.slice(5, 11)" @click="select(item.id)" :key="item.id+'nav_blog'" :class="{active: select_category == item.id}" class="blog-tabs-item">
          {{ item.name }}
        </div>
      </div>
      <div class="blog-tabs" v-if="categories.length > 11">
        <div v-for="item in categories.slice(11, 17)" @click="select(item.id)" :key="item.id+'nav_blog'" :class="{active: select_category == item.id}" class="blog-tabs-item">
          {{ item.name }}
        </div>
      </div>
      <div class="blog-tabs" v-if="categories.length > 17">
        <div v-for="item in categories.slice(17, 23)" @click="select(item.id)" :key="item.id+'nav_blog'" :class="{active: select_category == item.id}" class="blog-tabs-item">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="search ">
      <input name="search" autocomplete="off" :value="value" @input="$emit('input', $event.target.value)"  placeholder="Поиск по блогу" >
      <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">
    </div>
  </div>
</template>

<script>

export default {
  name: "BlogHeader",
  props:{
    value: {
      type: String
    },
    categories: {
      type: Array
    }
  },
  data: function () {
    return {
      select_category: 'Все'
    }
  },
  methods: {
    select(val) {
      this.select_category = val;
      this.$emit('change_category', val);
    }
  }
}
</script>

<style scoped lang="scss">
.blog-header {
  margin-bottom: 18px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  .search {
    position: relative;
    width: 20%;
    display: flex;
    justify-content: flex-end;

    > input {
      border: 1px solid #EEF0F3;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 40px;
      padding: 0 40px 0 15px;
      outline: none;

      &:focus{
        border: 1px solid #2CB181;
      }
    }

    > img {
      position: absolute;
      right: 15px;
      bottom: 50%;
      transform: translateY(50%);
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }
}

.blog-tabs{
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  width: max-content;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #EEF0F3;

  &-item {
    position: relative;
    cursor: pointer;
    padding: 10px 15px;
    margin: 2px 0 2px 0;
    color: #7A818F;
  }
  &-item:first-child{
    margin-left: 2px;
  }
  &-item:last-child{
    margin-right: 2px;
  }
  &-item.active {
    background: #EEF0F3;
    border-radius: 4px;
  }

  &-item:after{
    border-left: 1px solid #EEF0F3;
    content: " ";
    position: absolute;
    top: 35%;
    right: 0;
    height: 30%;
    margin-top: auto;
    margin-bottom: auto;
  }
  &-item:last-child:after{
    border-left: unset;
  }
}
</style>